import { ReactNode } from "react";

import Box from "ds/components/Box";
import { useHideOnScrollContext } from "components/HideOnScroll/HideOnScrollContext";

import styles from "./styles.module.css";

type RunPageWrapperProps = {
  children: ReactNode;
  withNavigationBar?: boolean;
};

const RunPageWrapper = ({ children, withNavigationBar }: RunPageWrapperProps) => {
  const { setScrollableElRef } = useHideOnScrollContext();
  return (
    <Box
      direction="column"
      padding="large"
      fullWidth
      gap="large"
      className={withNavigationBar ? styles.withNavigationBar : undefined}
      grow="1"
      scrollable
      style={{ height: "0" }}
      ref={setScrollableElRef}
    >
      {children}
    </Box>
  );
};

export default RunPageWrapper;
